import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment';

enum DateFormatType {
  DATE = 'date',
  DATE_PICKER = 'datepicker',
  FULL = 'full',
  FULL_DATE = 'fullDate',
  LONG_DATE = 'longDate',
  MEDIUM = 'medium',
  MEDIUM_DATE = 'mediumDate',
  MEDIUM_TIME = 'mediumTime',
  SHORT = 'short',
  SHORT_DATE = 'shortDate',
  SHORT_MONTH = 'shortMonth',
  SHORT_TIME = 'shortTime',
  SHORT_YEAR = 'shortYear',
  SPINNER = 'spinner',
  TIME_SPINNER = 'timeSpinner',
  TIME_STAMP = 'timestamp',
}

function format(value: string, dateFormatType: DateFormatType): string {
  return ModelService.format('date', value, { type: dateFormatType });
}

/**
 *
 * @param value date string value
 * @returns ex.: 28/03/2023
 */
function date(value: string): string {
  return format(moment(value).utc().format('L'), DateFormatType.DATE);
}

/**
 *
 * @param value date string value
 * @returns
 */
function datePicker(value: string): string {
  return format(value, DateFormatType.DATE_PICKER);
}

/**
 *
 * @param value date string value
 * @returns ex.: terça-feira, 28 de março de 2023 às 11:02
 */
function full(value: string): string {
  return format(value, DateFormatType.FULL);
}

/**
 *
 * @param value date string value
 * @returns
 */
function fullDate(value: string): string {
  return format(value, DateFormatType.FULL_DATE);
}

/**
 *
 * @param value date string value
 * @returns ex.: 28/03/2023
 */
function longDate(value: string): string {
  return format(value, DateFormatType.LONG_DATE);
}

/**
 *
 * @param value date string value
 * @returns ex.: 28 de mar de 2023 11:02
 */
function medium(value: string): string {
  return format(value, DateFormatType.MEDIUM);
}

/**
 *
 * @param value date string value
 * @returns
 */
function mediumDate(value: string): string {
  return format(value, DateFormatType.MEDIUM_DATE);
}

/**
 *
 * @param value date string value
 * @returns ex.: 20:23:03
 */
function mediumTime(value: string): string {
  return format(value, DateFormatType.MEDIUM_TIME);
}

/**
 *
 * @param value date string value
 * @returns ex.: 28/03/2023 11:02
 */
function short(value: string): string {
  return format(value, DateFormatType.SHORT);
}

/**
 *
 * @param value date string value
 * @returns ex.:28/03/2023
 */
function shortDate(value: string): string {
  return format(moment(value).utc().format('L'), DateFormatType.SHORT_DATE);
}

/**
 *
 * @param value date string value
 * @returns ex.: 03/2023
 */
function shortMonth(value: string): string {
  return format(moment(value).utc().format('L'), DateFormatType.SHORT_MONTH);
}

/**
 *
 * @param value date string value
 * @returns ex.: 11:02
 */
function shortTime(value: string): string {
  return format(moment(value).format('LT'), DateFormatType.SHORT_TIME);
}

/**
 *
 * @param value date string value
 * @returns ex.: 2023
 */
function shortYear(value: string): string {
  return format(value, DateFormatType.SHORT_YEAR);
}

/**
 *
 * @param value date string value
 * @returns
 */
function spinner(value: string): string {
  return format(value, DateFormatType.SPINNER);
}

/**
 *
 * @param value date string value
 * @returns
 */
function timeSpinner(value: string): string {
  return format(value, DateFormatType.TIME_SPINNER);
}

/**
 *
 * @param value date string value
 * @returns ex.: 28/03/2023 11:02:57
 */
function timeStamp(value: string): string {
  return format(value, DateFormatType.TIME_STAMP);
}

function timefieldToLocalTimezone(timefield: string): string {
  const time = timefield.split(':');
  return moment().hour(parseInt(time[0])).minute(parseInt(time[1])).add(moment().utcOffset(), 'minute').format('LT');
}

function timeFieldToTimezone(timeField: string): string {
  const time = timeField.split(':');

  return moment().hour(time[0] ? parseInt(time[0]) : 0)
    .minute(time[1] ? parseInt(time[1]) : 0)
    .second(time[2] ? parseInt(time[2]) : 0)
    .subtract(moment().utcOffset(), 'minute')
    .format('LTS');
}

const DateFormatterUtil = {
  date,
  datePicker,
  full,
  fullDate,
  longDate,
  medium,
  mediumDate,
  mediumTime,
  short,
  shortDate,
  shortMonth,
  shortTime,
  shortYear,
  spinner,
  timefieldToLocalTimezone,
  timeFieldToTimezone,
  timeSpinner,
  timeStamp,
}

export default DateFormatterUtil;
